import React from "react";
import { CalendarType } from "../../../../api/grpc/calendarprovider/calendarprovider";
import { tooltips } from "../../../../lib/utils/tooltips";
import { EWSProviderInput } from "../EWSProviderInput/EWSProviderInput";
import { RoomFormik } from "../../../shared/Forms/RoomForm/lib/useRoomFormik";
import { CalendarEmailSelect } from "../../CalendarEmailSelect/CalendarEmailSelect";
import { Providers } from "../../../../lib/context/Calendar/CalendarContextProvider";

interface Props {
  formik: RoomFormik;
  providers: Providers[];
  roomId?: string;
  index: number;
  label?: string;
  disabled?: boolean;
}

export const CrossOrgCalendarEmail = (props: Props) => {
  const { formik, providers, roomId, index, label, disabled } = props;

  const crossOrganizationIntegration =
    formik.values.crossOrganizationIntegration || [];
  const calendar = crossOrganizationIntegration[index];

  if (!calendar) {
    return null;
  }

  const isEWSProvider = providers.find(
    (item) =>
      item.iD === calendar.calendarProviderId &&
      item.calType === CalendarType.EWS
  );

  const activeProvider = providers.find(
    (item) => item.iD === calendar.calendarProviderId
  );
  const excludedCalendarIds = [
    formik.values.calendarId,
    ...crossOrganizationIntegration.map((integration) => integration.calendarId),
  ].filter(Boolean);

  const handleCalendarChange = (
    calendarId: string,
    resourceEmail: string = ""
  ) => {
    const newCalendars = [...crossOrganizationIntegration];
    newCalendars[index] = {
      ...newCalendars[index],
      calendarId,
      resourceEmail,
      order: newCalendars[index].order || index + 1,
    };
    formik.setFieldValue("crossOrganizationIntegration", newCalendars);
  };

  // CalendarEmailSelect calls setFieldValue("resourceEmail") before setFieldValue("calendarId"),
  // so we buffer it here and flush when calendarId arrives.
  let pendingResourceEmail = "";

  const nestedFormik = {
    values: {
      ...formik.values,
      calendarProviderId: calendar.calendarProviderId,
      calendarId: calendar.calendarId,
      calendarType: undefined,
    },
    errors: formik.errors,
    touched: formik.touched,
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      handleCalendarChange(e.target.value);
    },
    handleBlur: formik.handleBlur,
    setFieldValue: (field: string, value: any) => {
      if (field === "resourceEmail") {
        pendingResourceEmail = value;
      } else if (field === "calendarId") {
        handleCalendarChange(value, pendingResourceEmail);
        pendingResourceEmail = "";
      }
    },
    setFieldTouched: (field: string, touched?: boolean) => {
      formik.setFieldTouched(
        `crossOrganizationIntegration[${index}].${field}`,
        touched
      );
    },
  } as RoomFormik;

  return (
    <>
      {!!isEWSProvider ? (
        <EWSProviderInput
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            handleCalendarChange(e.target.value, e.target.value);
          }}
          value={calendar.calendarId}
          error={undefined}
          calendarProviderId={calendar.calendarProviderId}
          invalid={false}
          label={label}
          disabled={disabled}
        />
      ) : (
        <CalendarEmailSelect
          formik={nestedFormik}
          provider={calendar.calendarProviderId}
          message={tooltips.rooms.settings.calendarEmail}
          roomId={roomId}
          activeProvider={activeProvider}
          label={label}
          disabled={disabled}
          excludedCalendarIds={excludedCalendarIds}
        />
      )}
    </>
  );
};
